import React,{ useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ShipmentCloneAttributes from "./attributes";
import ShipmentCloneLocations from "./locations";
import ShipmentCloneFrequency from "./frequency";
import { updateUI } from "../../../store/actions/shipment";

function SelectedProfile() {
  const dispatch = useDispatch();
  const selectedProfileId = useSelector((state) => state.shipment.ui.editShipment.selectedProfileId); 
  const isCheckboxChecked = useSelector((state) => state.shipment.ui.editShipment.isCheckboxChecked);
  const shipmetProfile = useSelector((state) => state?.shipment?.data?.shipProfile);
  const { editField } = useSelector((state) => ({
    editField: state.shipment.ui.editShipment.editField,
  }));

  function getDeviceDetails(devices) {
    let result = devices?.find(device => device?.profileid === selectedProfileId);
    if (result) {
        return {
            attributes: result?.attributes,
            locations: result?.locations,
            frequencies: result?.frequencies,
            profilename:result?.profilename,
        };
    }
}
function getShipmentByid(profileid, key) {
  const item = shipmetProfile?.find(obj => obj?.profileid === profileid);
  return item ? item[key] : null;
}
useEffect(() => {
dispatch(updateUI({
  key: "editShipment",
  value: {
    editField: {
      ...editField,
      selectProfile: {
        value: {
          ...editField.selectProfile.value, 
          name: getShipmentByid(selectedProfileId, "profilename"),
          id: selectedProfileId, 
          locations:getShipmentByid(selectedProfileId, "locations"),
        },
      },
    },
  },
}));
}, [selectedProfileId])
  var extractedDetails = getDeviceDetails(shipmetProfile);
  var attributes= extractedDetails?.attributes;
  var locations= extractedDetails?.locations;
  var frequencies= extractedDetails?.frequencies;

  return (
    <div className="pt-3">
      <div
        className="font-face-vzw"
        style={{
          fontWeight: 700,
          fontSize: "30px",
        }}
      >
         <h6 className="model-inline-heading">{extractedDetails?.profilename}</h6>
      </div> 
      <div className="d-flex flex-column justify-content-center align-items-start py-2">
        <ShipmentCloneAttributes attributes={attributes}/>
      </div>
      <div className="d-flex flex-column justify-content-center align-items-start py-2">
        <ShipmentCloneLocations locations={locations}/>
      </div>
      <div className="d-flex flex-column justify-content-center align-items-start py-2">
        <ShipmentCloneFrequency frequencies={frequencies}/>
      </div>
    </div>
  );
}

export default SelectedProfile;
